module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/foreword"
    }
  }, [_vm._v("Prologue: Keep It Safe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/part001"
    }
  }, [_vm._v("Part I: The 17 Simple Rules "), _c('br'), _vm._v("of Financial Safety")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter001"
    }
  }, [_vm._v("RULE #1: Build Your Wealth upon Your Career")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter002"
    }
  }, [_vm._v("RULE #2: Don't Assume You Can Replace Your Wealth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RULE #3: Recognize the Difference between Investing and Speculating")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RULE #4: Beware of Fortune-Tellers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RULE #5: Don't Expect Anyone to Make You Rich")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RULE #6: Don't Expect a Trading System to Make You Rich")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RULE #7: Invest Only on a Cash Basis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RULE #8: Make Your Own Decisions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RULE #9: Do Only What You Understand")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RULE #10: Spread the Risk")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RULE #11: Build a Bulletproof Portfolio for Protection")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RULE #12: Speculate Only with Money You Can Afford to Lose")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RULE #13: Keep Some Assets Outside Your Own Country")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RULE #14: Take Advantage of Tax-Reduction Plans")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RULE #15: Ask the Right Questions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RULE #16: Enjoy Yourself with a Budget for Pleasure")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RULE #17: Whenever You're in Doubt, Err on the Side of Safety")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/part002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II: More about the Rules")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RULE #1: More about Your Career and Your Wealth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RULE #2: More about Protecting Your Wealth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RULE #3: More about Investing and Speculating")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RULE #4: More about Fortune-Tellers and Forecasts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RULE #5: More about Relying on an Investment Expert")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RULE #6: More about Trading Systems")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RULE #7: More about Investing on a Cash Basis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RULE #8: More about Making Your Own Decisions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RULE #9: More about Understanding What You Do")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RULE #10: More about Spreading the Risk")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RULE #11: More about the Bulletproof Portfolio")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RULE #12: More about Speculating")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RULE #13: More about Keeping Some Assets Overseas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RULE #14: More about Tax-Reduction Plans")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RULE #15: More about Asking the Right Questions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RULE #16: More about the Pleasure Budget")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RULE #17: More about Erring on the Side of Safety")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/afterword",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue:")]), _vm._v(" Getting On with Your Life")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/appendix001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendices")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/appendix001#h1-79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/appendix001#h1-80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Where to Get Help")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/appendix001#h1-86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. The Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78a90703","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 72
// module chunks = 0